import { ITermSchema } from '../../internalTypes';
import { ICalltracking } from '../../../../../redux/reducers';
import { mapPeriod } from '../mapPeriod';
import { isCalltrackingPaid } from './isCalltrackingPaid';
import { isCalltrackingEnabled } from './isCalltrackingEnabled';
import { getSelectedPeriodId } from './getSelectedPeriodId';

export const mapCalltracking = (calltrackingTerm: ITermSchema | null): ICalltracking => {
  const {
    isAvailable = false,
    isCompulsory = false,
    isAdditional = false,
    services,
    incompatibleServices,
    publishOptions,
    calltrackingPhoneSubstitutionsCount = null,
  } = calltrackingTerm || {};

  const rawPeriods = publishOptions?.periods || [];
  const periods = rawPeriods.map(mapPeriod);
  const selectedPeriodId = getSelectedPeriodId(rawPeriods);

  const isPaid = isCalltrackingPaid(periods);
  const isEnabled = isCalltrackingEnabled({ isAvailable, isCompulsory, isPaid });

  return {
    isAvailable,
    isEnabled,
    services: services || [],
    incompatibleServices: incompatibleServices || [],
    isCompulsory,
    isAdditional,
    calltrackingPhoneSubstitutionsCount,
    periods,
    selectedPeriodId,
  };
};
